// Static on/off switches for the staff sidebar/bottom-nav menu items.
// Set any flag to `false` to completely remove that item from navigation
// (sidebar, bottom nav, and topbar shortcuts alike) — it's a build-time
// config, not tied to the backend feature-flag system used elsewhere
// (see StaffSessionService.isFeatureEnabled for that, per-school one).
export const staffMenuBarFeature = {
  dashboard: false,
  allClasses: true,
  myTimetable: true,
  broadcast: true,
  academicCalendar: true,
  feesCollection: true,
  feesReports: true,
  transport: true,
  checkInCheckOut: true,
  search: true,
  profile: true,
  // "View Staff Attendance" — an in-app list of the whole school's staff
  // check-in/out log, sourced from Hourhive. Gated on HOURHIVE (extension
  // service) + Super Admin role — see viewStaffAttendanceMenuGuard.
  viewStaffAttendance: true,
  // Gated on the backend STUDENT_LEAVE_MANAGEMENT feature flag — see
  // leaveManagementMenuGuard.
  leaveManagement: true,
};
